import { rootApi } from '@components/rootApi';
import {
  accountManagersResponse,
  AccountManagersResponse,
  podsResponse,
  PodsResponse,
} from './schema';

const pathWithBaseUrl = (path: string) => `/api/v2/users/${path}`;

const usersApi = rootApi.injectEndpoints({
  endpoints: builder => ({
    getAccountManagers: builder.query<AccountManagersResponse, void>({
      query: () => pathWithBaseUrl(`account_managers`),
      transformResponse: response => accountManagersResponse.parse(response),
    }),
    getPodsV2: builder.query<PodsResponse, void>({
      query: () => pathWithBaseUrl('pods'),
      transformResponse: response => podsResponse.parse(response),
    }),
  }),
});

export const { useGetAccountManagersQuery, useGetPodsV2Query } = usersApi;
